import { PencilSimpleLine } from '@phosphor-icons/react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { UpdatePricingProfiles } from 'pricing/components';
import { PricingProfilePricingType } from 'pricing/enums';
import { Variant } from 'theme/enums';

interface IProps {
  type: PricingProfilePricingType;
}

export const UpdateSelectedProfiles = ({ type }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { gridApi, selectedRows, deselectAllRows } = useAgGridTableContext();

  const onSubmitSuccess = useCallback(() => {
    gridApi?.refreshServerSide();
    deselectAllRows();
  }, [deselectAllRows, gridApi]);

  return (
    <>
      <Button
        text={t('buttonLabelUpdate')}
        variant={Variant.PLAIN}
        startDecorator={<PencilSimpleLine />}
        onClick={() => setIsOpen(true)}
      />

      <UpdatePricingProfiles
        pricingProfiles={selectedRows}
        type={type}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
